import { queryOptions, useMutation } from '@tanstack/react-query'

import {
  acceptCustomerRequestedQuote,
  getCustomerRequestedQuotes,
  withdrawCustomerRequestedQuote,
} from './customer-requested-quotes.service'

export const customerRequestedQuotesQueryOptions = () =>
  queryOptions({
    queryKey: ['customerRequestedQuotes'],
    queryFn: getCustomerRequestedQuotes,
    retry: false,
    throwOnError: false,
  })

export const useWithdrawCustomerRequestedQuote = () => {
  return useMutation({
    mutationFn: (params: { quoteId: string; reasons: string[] }) =>
      withdrawCustomerRequestedQuote(params.quoteId, { reasons: params.reasons }),
  })
}

export const useAcceptCustomerRequestedQuote = () => {
  return useMutation({
    mutationFn: (params: { quoteId: string; reasons: string[] }) => acceptCustomerRequestedQuote(params.quoteId),
  })
}
